import { Observable } from 'rxjs';
import { filter, map, share, shareReplay } from 'rxjs/operators';

import { Injectable, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd, NavigationStart } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class SnRouterHelperService implements OnDestroy {
  public readonly navigationEnd$: Observable<NavigationEnd>;
  public readonly navigationStart$: Observable<NavigationStart>;

  public readonly routeChange$: Observable<ActivatedRoute>;

  constructor(private readonly _router: Router, private readonly _activatedRoute: ActivatedRoute) {
    this.navigationEnd$ = this._createNavigationEndSubscription();
    this.navigationStart$ = this._createNavigationStartSubscription();

    this.routeChange$ = this._createRouteChangeSubscription();
  }

  public ngOnDestroy(): void {}

  private _createNavigationEndSubscription(): Observable<NavigationEnd> {
    return this._router.events.pipe(
      filter<NavigationEnd>((event) => event instanceof NavigationEnd),
      share(),
    );
  }

  private _createNavigationStartSubscription(): Observable<NavigationStart> {
    return this._router.events.pipe(
      filter<NavigationStart>((event) => event instanceof NavigationStart),
      share(),
    );
  }

  private _createRouteChangeSubscription(): Observable<ActivatedRoute> {
    return this.navigationEnd$.pipe(
      map(() => this._activatedRoute),
      map((route) => {
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
      shareReplay(),
    );
  }
}
